import React, { createContext, useState, useEffect, useContext } from "react";
import { AuthContext } from "./AuthContext";
import { fetchSites } from "../services/ripAPI"; // Adjust the import path as necessary


export const SitesContext = createContext();

export const SitesProvider = ({ children, member, token }) => {
  const [sites, setSites] = useState([]);
  const [sitesDetails, setSitesDetails] = useState([]);
  const [loading, setLoading] = useState(true); // Add loading state
  const { setGlobalError, apiConfigured, resetTrigger, refreshTrigger } = useContext(AuthContext);

  useEffect(() => {
    const fetchSitesCall = async () => {
      
      if (!apiConfigured) {
        console.warn('SitesContext: API not yet configured, skipping fetch');
        return;
      }
      
      try {
        const sites = await fetchSites(member.acct_id);
        // In a real scenario, you'd use:
        // const sites = await fetchSites(member.acct_id);
        // For now, let's assume the API returns an array of site objects
        // create an array of just the site external_names from the sites array returned
        const siteExternalNames = sites.map((site) => site.external_name);
        // create an array of site objects where the key is the external_name and the value is the site object
        const siteDetails = sites.reduce((acc, site) => {
          acc[site.external_name] = site;
          return acc;
        }, {});
        // set the sites and sitesDetails state
        setSitesDetails(siteDetails);
        setSites(siteExternalNames);
      } catch (err) {
        setGlobalError("Failed to fetch sites");
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };

    if (member && member.acct_id && apiConfigured) {
      fetchSitesCall();
    } else {
      setLoading(false); // No member or API not configured, no need to fetch
    }
  }, [member, setGlobalError, apiConfigured, refreshTrigger]);

  // Watch for reset trigger from AuthContext
  useEffect(() => {
    if (resetTrigger > 0) {
      resetSites();
    }
  }, [resetTrigger]);

  // Watch for refresh trigger from AuthContext (for account switching)
  useEffect(() => {
    if (refreshTrigger > 0 && member && member.acct_id && apiConfigured) {
      setLoading(true);
      const fetchSitesCall = async () => {
        try {
          const sites = await fetchSites(member.acct_id);
          const siteExternalNames = sites.map((site) => site.external_name);
          const siteDetails = sites.reduce((acc, site) => {
            acc[site.external_name] = site;
            return acc;
          }, {});
          setSitesDetails(siteDetails);
          setSites(siteExternalNames);
        } catch (err) {
          setGlobalError("Failed to fetch sites");
        } finally {
          setLoading(false);
        }
      };
      fetchSitesCall();
    }
  }, [refreshTrigger, member, apiConfigured, setGlobalError]);

  const resetSites = () => {
    setSites([]);
    setSitesDetails([]);
    setLoading(true);
  };

  return (
    <SitesContext.Provider value={{ sites, setSites, sitesDetails, loading, resetSites }}>
      {children}
    </SitesContext.Provider>
  );
};
